import styled from "styled-components";

const SecondaryTitleWrapper = styled.div`
  max-width: ${(props) => (props.maxWidth ? props.maxWidth : "fit-content")};
  font-size: ${(props) => (props.fontSize ? props.fontSize : "14px")};
  font-weight: ${(props) => (props.fontWeight ? props.fontWeight : 800)};
  color: ${(props) => (props.color ? props.color : "#222222")};
  margin-top: ${(props) => (props.marginTop ? props.marginTop : "0")};
  margin-bottom: ${(props) => (props.marginBottom ? props.marginBottom : "0")};
  line-height: ${(props) => (props.lineHeight ? props.lineHeight : "")};
`;

export default SecondaryTitleWrapper;
